import * as React from 'react';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/icons-material/ViewList": ViewListIcon, "@mui/icons-material/ViewModule": ViewModuleIcon, "@mui/icons-material/ViewQuilt": ViewQuiltIcon, "@mui/material/ToggleButton": ToggleButton, "@mui/material/ToggleButtonGroup": ToggleButtonGroup } } });
export default ClientProvider;
